module.exports = __webpack_public_path__ + "img/22.f809f787.png";